import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7193254b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-layer-group" })
], -1))
const _hoisted_4 = {
  key: 4,
  class: "text-center"
}
const _hoisted_5 = {
  key: 5,
  class: "text-center"
}
const _hoisted_6 = {
  key: 6,
  class: "text-center"
}
const _hoisted_7 = {
  key: 7,
  class: "text-center"
}
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = { class: "flex items-center pb-1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "-", -1))
const _hoisted_12 = {
  key: 11,
  class: "relative flex items-center justify-end"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h fa-rotate-90" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_icon_rocket = _resolveComponent("icon-rocket")!
  const _component_new_table_action = _resolveComponent("new-table-action")!
  const _component_new_table_actions = _resolveComponent("new-table-actions")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.pickup_state.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Код выдачи посылки курьеру",
          onCancel: _ctx.closePickup,
          "without-footer": ""
        }, {
          default: _withCtx(() => [
            (_ctx.pickup_state.is_loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_loader, { class: "primary" })
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_2, "Код: " + _toDisplayString(_ctx.pickup_state.code || '-'), 1))
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (['invoiceNumber', 'title'].includes(_ctx.column.key))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
                'flex items-center cursor-pointer select-none',
                { 'justify-start': _ctx.regularTable, 'justify-center': !_ctx.regularTable },
            ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitToggle(_ctx.row)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["fas fa-chevron-down transition-all mr-2", { 'fa-rotate-180': _ctx.expanded }])
          }, null, 2),
          _hoisted_3,
          _createElementVNode("div", null, _toDisplayString(_ctx.row.title), 1)
        ], 2))
      : (_ctx.column.key === 'createdAt')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
          ], 64))
        : (_ctx.column.key === 'deliveryDate')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.deliveryDate)), 1)
            ], 64))
          : (_ctx.column.key === 'stopsCount')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
            : (_ctx.column.key === 'weight')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
              : (_ctx.column.key === 'volumeWeight')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
                : (_ctx.column.key === 'places')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
                  : (_ctx.column.key === 'containerStatus' && _ctx.row.status)
                    ? (_openBlock(), _createBlock(_component_cheap, {
                        key: 8,
                        class: _normalizeClass(["w-max small", _ctx.getClass])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.row.status.title || '-'), 1)
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : (_ctx.column.key === 'courier')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                          (_ctx.row.courier)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_ctx.row.fastDeliveryCourier)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_icon_rocket, {
                                          class: "mr-1",
                                          style: {"width":"-webkit-fill-available"}
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCourierTitle), 1)
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.row.fastDeliveryCourier), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.row.fastDeliveryPhone), 1),
                                      (_ctx.row.trackingUrl)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "link",
                                            href: _ctx.row.trackingUrl,
                                            target: "_blank"
                                          }, " отследить ", 8, _hoisted_10))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.row.courier.fullName), 1)
                                    ], 64))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_ctx.column.key === 'courierName')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                            (_ctx.row.courierName)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.row.provider)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.row.courierName), 1),
                                        _createElementVNode("p", null, "(" + _toDisplayString(_ctx.row.provider) + ")", 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.row.courierName), 1)
                                      ], 64))
                                ], 64))
                              : (_ctx.row.provider)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_11,
                                    _createElementVNode("p", null, "(" + _toDisplayString(_ctx.row.provider) + ")", 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(" - ")
                                  ], 64))
                          ], 64))
                        : (_ctx.column.key === 'actions')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_new_button, { class: "NewButton--secondary NewButton--small" }, {
                                popup: _withCtx(() => [
                                  _createVNode(_component_new_table_actions, { left: "" }, {
                                    default: _withCtx(() => [
                                      (_ctx.row.fastDeliveryId)
                                        ? (_openBlock(), _createBlock(_component_new_table_action, {
                                            key: 0,
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pickupCode(_ctx.row.fastDeliveryId)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Получить код выдачи ")
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                              _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                            ], 64))
  ], 64))
}